export default str => {
	str = str.trim();
	var split = str.match(/\d\d:\d\d[A|P]M/g);
	if (str === 'Closed') {
		return str;
	}
	if (split && split[0] !== split[1]) {
		return split.map(function(cur) {
			return cur[0] === '0' ? cur.substr(1) : cur;
		}).join(' - ');
	}

	return '24 Hours';
};